import React, { useState, useEffect, useRef } from "react";
import { getAuth, signOut, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import logoutIcon from "../assets/logout.svg";

const UserMenu = ({ user, onSignOut, onSignIn, isCollapsed }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        onSignOut();
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  };

  const handleSignIn = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        onSignIn(result.user);
      })
      .catch((error) => {
        console.error("Error signing in:", error);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target.classList.contains("react-flow__background")
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Common styles object for better maintenance
  const styles = {
    container: {
      position: "relative",
      display: "flex",
      justifyContent: isCollapsed ? "flex-start" : "flex-start",
      alignItems: "center",
      flexDirection: "column",
      width: "100%",
      padding: isCollapsed ? "10px 8px" : "10px 16px",
    },
    userIcon: {
      cursor: "pointer",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#fff",
      border: "2px solid #000",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    dropdownMenu: {
      position: "absolute",
      bottom: "64px",
      left: isCollapsed ? "50%" : "16px",
      transform: isCollapsed ? "translateX(-50%)" : "none",
      background: "#1e1e1e",
      border: "1px solid #333",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      zIndex: 9999,
      minWidth: "200px",
      textAlign: "center",
    },
    menuItem: {
      padding: "10px 20px",
      display: "flex",
      alignItems: "center",
      gap: "14px",
      cursor: "pointer",
      color: "#fff",
      transition: "background 0.2s",
      borderRadius: "8px",
    },
    signInButton: {
      cursor: "pointer",
      padding: isCollapsed ? "10px" : "10px 20px",
      background: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontFamily: "'Poppins', sans-serif",
      fontSize: "14px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      transition: "all 0.3s ease",
      width: isCollapsed ? "40px" : "auto",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: isCollapsed ? "40px" : "100px",
    },
  };

  return (
    <div ref={menuRef} style={styles.container}>
      {user ? (
        <>
          <div onClick={toggleMenu} style={styles.userIcon}>
            <img
              src={user.photoURL}
              alt="User Avatar"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>

          {isMenuOpen && (
            <div style={styles.dropdownMenu}>
              <div
                style={styles.menuItem}
                onClick={handleSignOut}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#333")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <img
                  src={logoutIcon}
                  alt="Logout"
                  style={{ width: "16px", height: "16px" }}
                />
                <span style={{ fontSize: "14px", fontFamily: "'Poppins', sans-serif" }}>
                  Log out
                </span>
              </div>
            </div>
          )}
        </>
      ) : (
        <button
          onClick={handleSignIn}
          style={styles.signInButton}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#0056b3")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#007bff")}
        >
          {isCollapsed ? "→" : "Sign In"}
        </button>
      )}
    </div>
  );
};

export default UserMenu;